import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import ProUpgradeModal from './ProUpgradeModal';

/**
 * PRO Route wrapper - redirects non-PRO users to dashboard with a PRO modal.
 * Admin users always have PRO access.
 * Leaders/members need isPro flag to access PRO features.
 */
const ProRoute = ({ children }) => {
  const { user } = useAuth();
  const [showModal, setShowModal] = React.useState(false);

  const hasProAccess = user && (
    user.role === 'admin' || 
    (user.isPro && (!user.proExpiresAt || new Date(user.proExpiresAt) > new Date()))
  );

  if (!hasProAccess) {
    return (
      <>
        <ProUpgradeModal open={true} onClose={() => window.history.back()} />
      </>
    );
  }

  return children;
};

export default ProRoute;
